import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_modules/_app/assortment/active')({
  staticData: {
    title: 'route.assortment.active',
    crumb: 'route.assortment.active',
    permissions: ['active_assortment_view'],
  },
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
